import {MainException} from 'common/exception/MainException';
import {ExceptionContract} from 'common/exception/ExceptionContract';

export class InternalException extends MainException implements ExceptionContract {
    public constructor(message: string, data?: {[key: string]: any}) {
        super(message, 500, data);
        this.name = 'InternalException';
    }
}
